import { __, getConfig } from "@jti/fe-common";
import { daysArray, monthsArray } from "@jti/ui";
const DEFAULT_MIN_AGE = 18;
const getRegularFormValues = (dobFormType) => {
    const config = getConfig();
    const MIN_AGE_TO_REGISTER = parseInt(config.MIN_AGE_TO_REGISTER) || DEFAULT_MIN_AGE;
    const emptyValuesFormTypes = ["dropdowns_empty", "dropdowns_empty_reversed", "inputs", "inputs_reversed"];
    const getDobInitialValues = () => {
        if (emptyValuesFormTypes.includes(dobFormType)) {
            return {
                dobDay: undefined,
                dobMonth: undefined,
                dobYear: undefined,
            };
        }
        return {
            dobDay: daysArray[new Date().getDate() - 1],
            dobMonth: monthsArray(__)[new Date().getMonth()],
            dobYear: {
                label: `${new Date().getFullYear() - MIN_AGE_TO_REGISTER}`,
                value: `${new Date().getFullYear() - MIN_AGE_TO_REGISTER}`,
            },
        };
    };
    return {
        email: "",
        password: "",
        firstname: "",
        lastname: "",
        telephone: "",
        phone_validation_code: "",
        registrationCode: "",
        phone_validation_uuid: "",
        email_validation_code: "",
        email_validation_uuid: "",
        age_verification_uuid: "",
        referral_code: "",
        dob: getDobInitialValues(),
        date_of_birth: "",
        isPolicyRead: false,
        promoEmail: false,
        promoSms: false,
        custom_attributes: {
            city: "",
            post_code: "",
        },
        streetName: "",
        streetNumber: "",
        streetAdditional: "",
        purposes: {},
    };
};
const getKakaoFormValues = (code) => {
    return {
        referral_code: "",
        date_of_birth: "",
        age_verification_uuid: "",
        code,
        registrationCode: "",
    };
};
const getInitialFormValues = ({ registrationFlowName, code, dobFormType = "dropdowns_filled", }) => {
    const initialFormValues = {
        kakao: getKakaoFormValues(code),
        regular: getRegularFormValues(dobFormType),
    };
    return initialFormValues[registrationFlowName];
};
export { getInitialFormValues };
